import { cloneDeep } from 'lodash';

import { Box } from '@hivebrite/design-system/Box';

import { DYNAMIC_VIDEO_SELECTOR_OPTIONS } from 'hb-builder/components/BuilderComponents/single/Video/constants';
import DeleteImageSource from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DeleteImageSource';
import EditImageSource from 'hb-builder/components/common/SettingsLibrary/CommonSettings/EditImageSource';
import SelectSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/SelectSetting';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import UploadVideoButton from 'hb-builder/components/common/SettingsLibrary/CommonSettings/UploadVideoButton';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { VideoItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/videoItemAttributes';
import { VIDEO_TYPE_ATTRIBUTE } from 'hb-react/backoffice/types/builder/itemAttributes/videoItemAttributes';

const ContentVideoUpload = ({
  item,
  onChange,
}: Pick<ComponentSettingsTab<VideoItemAttributes>, 'item' | 'onChange'>) => {
  const settingProps = { item, onChange };
  const { attributes } = item;

  const handleChangeAndReset = ({
    id,
    value,
  }: {
    id: string;
    value: string;
  }) => {
    onChange({
      id,
      settingKey: 'attributes',
      value: {
        ...cloneDeep(attributes),
        type: value,
        videoImageSrc: '',
        videoUrl: '',
      },
    });
  };

  if (!attributes) {
    return null;
  }

  return (
    <>
      <SelectSetting
        item={item}
        onChange={handleChangeAndReset}
        options={DYNAMIC_VIDEO_SELECTOR_OPTIONS}
        settingKey="type"
        title={s__('Builder|Video Type')}
      />
      {attributes.type === VIDEO_TYPE_ATTRIBUTE.UPLOADED_FILE && (
        <>
          <Box mt={-2} mb={3}>
            {s__(
              "Builder|Recommended format is mp4 and your file can't exceed 1Go.",
            )}
          </Box>
          <UploadVideoButton
            item={item}
            hasVideo={!!attributes.videoUrl}
            attributeType="videoUrl"
          />
        </>
      )}
      {attributes.type === VIDEO_TYPE_ATTRIBUTE.LINK && (
        <TextSetting
          disabled={false}
          initialValue={undefined}
          settingKey="attributes.videoUrl"
          title={__('Enter URL')}
          verticalAlign
          {...settingProps}
        />
      )}

      <InputTitle
        id="settingsImage"
        label={__('Thumbnail image')}
        boxProps={{
          mb: -1,
          ...(attributes.type !== VIDEO_TYPE_ATTRIBUTE.LINK && { mt: 4 }),
        }}
        position={undefined}
      />
      <Box mb={2}>{s__('Builder|Recommended size is 1280x720 pixels.')}</Box>
      <EditImageSource hasImage={!!attributes.videoImageSrc} id={item.id} />
      {attributes.videoImageSrc && (
        <DeleteImageSource
          settingKey="attributes.videoImageSrc"
          {...settingProps}
        />
      )}
    </>
  );
};

export default ContentVideoUpload;
